/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplateCosoAmbitoDTO} from './TemplateCosoAmbitoDTO';

/**
 * The TemplateCosoRequisitoDTO model module.
 * @module model/TemplateCosoRequisitoDTO
 * @version v0
 */
export class TemplateCosoRequisitoDTO {
  /**
   * Constructs a new <code>TemplateCosoRequisitoDTO</code>.
   * @alias module:model/TemplateCosoRequisitoDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateCosoRequisitoDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateCosoRequisitoDTO} obj Optional instance to populate.
   * @return {module:model/TemplateCosoRequisitoDTO} The populated <code>TemplateCosoRequisitoDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateCosoRequisitoDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('templateCosoAmbiti'))
        obj.templateCosoAmbiti = ApiClient.convertToType(data['templateCosoAmbiti'], [TemplateCosoAmbitoDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
TemplateCosoRequisitoDTO.prototype.id = undefined;

/**
 * @member {String} title
 */
TemplateCosoRequisitoDTO.prototype.title = undefined;

/**
 * @member {Number} position
 */
TemplateCosoRequisitoDTO.prototype.position = undefined;

/**
 * @member {Array.<module:model/TemplateCosoAmbitoDTO>} templateCosoAmbiti
 */
TemplateCosoRequisitoDTO.prototype.templateCosoAmbiti = undefined;

/**
 * @member {String} tooltip
 */
TemplateCosoRequisitoDTO.prototype.tooltip = undefined;

